import { getItemFromLS, setItemToLS } from './LocalStorage';

export function applyGroupFilterToUserTable(
  profileId: string | undefined,
  groupId: string,
  groupName: string
): void {
  const key = 'dcone-table/user-table-' + (profileId ?? '');
  const storedTableDataStr = getItemFromLS(key) as string;
  if (!storedTableDataStr) return;

  let storedTableData: any;
  try {
    storedTableData = JSON.parse(storedTableDataStr);
  } catch {
    return;
  }

  const groupFilter = {
    value: groupId,
    label: groupName,
    description: groupName,
    key: `groups.${groupName}`,
    func: 'eq'
  };

  const defaultFilters = {
    ...storedTableData.meta?.filters,
    groups: [groupFilter]
  };

  const groupFilterTag = {
    label: 'User group',
    field: 'groups',
    value: groupFilter
  };

  const updatedData = {
    ...storedTableData,
    meta: {
      ...storedTableData.meta,
      filters: defaultFilters,
      appliedFiltersTags: [
        ...(storedTableData.meta?.appliedFiltersTags || []),
        groupFilterTag
      ]
    }
  };

  setItemToLS(key, JSON.stringify(updatedData));
}
